export const defaultSettingConfig = {
  min: 0,
  max: 100,
  step: 1,
};

export type SliderSettingConfig = typeof defaultSettingConfig;
